module.exports = __webpack_public_path__ + "img/frances-gunn-blurred-12.webp";